module.exports = __webpack_public_path__ + "275420470b85e5a3ae20b08329817bfe.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/7_F#2.mp3
// module id = 123
// module chunks = 0